/* ============================================================
   Plainview — Landing moderna
   Punto de entrada. Comportamiento de
   templates/landing-moderna/LandingModerna.dc.html: el template original corre
   sobre el runtime DC (clase DCLogic con state/props); acá esa lógica está
   traducida a módulos de navegador.
   ============================================================ */

import { initNav } from './modules/nav.js';
import { initReveal } from './modules/reveal.js';
import { initProgress } from './modules/progress.js';
import { initStats } from './modules/stats.js';
import { initTabs } from './modules/tabs.js';
import { initModal } from './modules/modal.js';
import { initForm } from './modules/form.js';

function init() {
  initNav();
  initReveal();
  initProgress();
  initStats();
  initTabs();
  initModal();
  initForm();
}

// El módulo se ejecuta diferido, así que el DOM ya está listo; el guard queda
// por si el script se mueve al <head> sin type="module".
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
